<!--
Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.
-->

<div>
<div class="text-end mt-2 sticky-top">
    <mat-icon mat-dialog-close class="me-3">close</mat-icon>
 </div>
<div class="privacy-policy p-4 pt-0">
    <h3>Privacy policy</h3>
    <hr>
    <div class="privacy-content">
    <section>
        <h6>1. Introduction</h6>
        <p>At SITA, we are committed to protecting your personal data and respecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information in accordance with applicable privacy and data protection laws including the General Data Protection Regulation (GDPR) where it applies.</p>
    </section>

    <section>
        <h6>2. Data We Collect</h6>
        <ul>
            <li><strong>Email Address</strong> – used for communication, account verification.</li>
            <li><strong>Username</strong> – used to identify your account within our service.</li>
            <li><strong>Login Data</strong> – includes login timestamps, IP address for security and auditing purposes.</li>
        </ul>
    </section>

    <section>
        <h6>3. Purpose of Data Collection</h6>
        <p>We collect and process your data for the following purposes:</p>
        <ul>
            <li>To create and manage your user account.</li>
            <li>To provide access to our services.</li>
            <li>To ensure the security of our platform.</li>
            <li>To communicate important updates or service-related information.</li>
            <li>To comply with legal obligations.</li>
        </ul>
    </section>

    <section>
        <h6>4. Legal Basis for Processing</h6>
        <p>Under GDPR, we rely on the following legal bases:</p>
        <ul>
            <li><strong>Consent</strong> – when you voluntarily provide your data.</li>
            <li><strong>Contractual necessity</strong> – to provide the services you request.</li>
            <li><strong>Legitimate interests</strong> – to improve our services and ensure security.</li>
            <li><strong>Legal obligation</strong> – to comply with applicable laws and regulations.</li>
        </ul>
    </section>

    <section>
        <h6>5. Data Retention</h6>
        <p>We retain your personal data only for as long as necessary to fulfill the purposes outlined in this policy, or as required by law.</p>
    </section>

    <section>
        <h6>6. Data Sharing and Transfers</h6>
        <p>We do <strong>not</strong> sell or rent your personal data. We may share your data with:</p>
        <ul>
            <li>Trusted third-party service providers (e.g., hosting, analytics) under strict data protection agreements.</li>
            <li>Legal authorities, if required by law.</li>
        </ul>
        <p>If data is transferred outside the European Economic Area (EEA), we ensure appropriate safeguards are in place.</p>
    </section>

    <section>
        <h6>7. Your Privacy Rights</h6>
        <p>Based on location and applicable privacy and data protection regulations, you may have the right to:</p>
        <ul>
            <li>Access your personal data.</li>
            <li>Correct inaccurate or incomplete data.</li>
            <li>Request deletion of your data (“right to be forgotten”).</li>
            <li>Restrict or object to processing.</li>
            <li>Data portability.</li>
            <li>Withdraw consent at any time.</li>
        </ul>
        <p>To exercise your rights, contact us at: Bagisupport&#64;sita.aero</p>
    </section>

    <section>
        <h6>8. Security Measures</h6>
        <p>We implement appropriate technical and organizational measures to protect your data from unauthorized access, loss, or misuse.</p>
    </section>

    <section>
        <h6>9. Changes to This Policy</h6>
        <p>We may update this Privacy Policy from time to time. We will notify you of significant changes and update the “last updated” date below.</p>
    </section>

    <section>
        <h6>10. Contact Us</h6>
        <p>If you have any questions or concerns about this Privacy Policy or your data, please contact: Bagisupport&#64;sita.aero</p>
    </section>

    <footer style="margin-bottom: 0.75rem;">&copy;SITA - last updated: 12th August 2025</footer>
</div>
</div>
</div>
